const translations = {
    mapDeleteError: 'Error deleting as applied map. Please try again later.',
    noData: 'No data available'
};

export default translations;
